import { Component, OnInit, Inject } from '@angular/core';
import { PublicidadDashboard } from 'src/app/shared/model/publicidad-dashboard/publicidadDashboard.model';
import { FormGroup, Validators, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';

import { SolicitudTicketsComponent } from '../../tickets/solicitud/solicitud-tickets/solicitudTickets.component';
import { DashboardService } from '../service/dashboard.service';
import swal from 'sweetalert2';
import { Msg } from 'src/app/utilerias/mensajes/Msg';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatInput, MatError } from '@angular/material/input';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-model-publicidad',
    templateUrl: './model-publicidad.component.html',
    styleUrls: ['./model-publicidad.component.css'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatFormField, MatInput, NgIf, MatError, MatButton, MatDialogActions]
})
export class ModelPublicidadComponent implements OnInit {

  publicidad: PublicidadDashboard;
  
  options: FormGroup;
  evidencia = [];
  totalsize = 0;
  showImagen: boolean;
  showBtnAddImagen: boolean;
  showBtnGuardar: boolean;
  nombreImagen: string ;

  constructor(private fb: FormBuilder, 
    public modal: MatDialogRef<SolicitudTicketsComponent>,
     private service: DashboardService,
    @Inject(MAT_DIALOG_DATA) public data: PublicidadDashboard, private msg :Msg) { }

  ngOnInit() {
    this.showBtnAddImagen=true;
    
    if(this.data == null){
      this.publicidad = new PublicidadDashboard();
      this.showImagen=false;
      this.showBtnGuardar=false;
  }else{
      console.log('this.data :::', this.data);
      this.showImagen=true;
      this.showBtnGuardar=true;
      this.publicidad = this.data;//Object.assign({}, this.data.datos)// estructura para Clonar un objeto
  }

    this.options = this.fb.group({
      tituloCtrl: ['', Validators.required],
      urlCtrl: ['', Validators.required],
      descripcionCtrl: [''],
      imagenCtrl: ['']
    });

  }

  limpiar(): void {
    this.options.reset();
    this. elimina() 
  }

  salir() {
    this.modal.close();
  }

  guardar(): void {
    console.log('this.publicidad'+this.publicidad);
    this.service.guardarTarjetaDePublicidad(this.publicidad).subscribe({ next: res => {
      // La publicidad la ven todos los corporativos y solo la administra la
      // plataforma: si el servidor no la guardo (p. ej. sin permiso) contesta
      // con un codigo distinto de 00000 y no se sube la imagen.
      if (res != null && Number(res.pCodRetorno) === 0) {
        for (let i = 0; i < this.evidencia.length; i++) {
          const formData = new FormData();
          formData.append('file', this.evidencia[i], "$" + res.id + "$" + this.evidencia[i].name);
          this.service.guardaImagenPublicidad(formData).subscribe();
        }
        swal.fire({
          title: '¡Se ha generado una nueva Tarjeta de publicidad para el dashboard de inicio.! ',
          timer: 5000,
          icon: 'success',
          showConfirmButton: true
        }).then(responeMsg => {
          this.modal.close(this.publicidad);
        });
      } else {
        swal.fire({
          title: 'Fallo el guardado de la nueva Tarjeta de publicidad.',
          text: res?.pMensaje || '',
          timer: 5000,
          icon: 'error',
          showConfirmButton: true
        });
      }
    }, error: () => {
      swal.fire({
        title: 'Fallo el guardado de la nueva Tarjeta de publicidad.',
        timer: 5000,
        icon: 'error',
        showConfirmButton: true
      });
    } });
  }

  subirEv() {
    const input = (<HTMLInputElement>document.getElementById('nameFile'));
    if (input.files.length > 0) {
      for (let i = 0; i <= input.files.length - 1; i++) {
        this.totalsize = this.totalsize + input.files.item(i).size;
        this.evidencia.push(input.files[i]);
      }
    }
    var extencion;
    for (let i = 0; i < this.evidencia.length; ++i) {
      this.nombreImagen = this.evidencia[i].name
      var arrayDeCadenas = this.nombreImagen.split('.');
      extencion=arrayDeCadenas[1].toUpperCase();
      if(extencion == 'JPG' || extencion == 'PNG'){
        this.showImagen=false;
        this.showBtnAddImagen=false;
        this.showBtnGuardar=true;
      }else{
        this.elimina();
        this.msg.warningCall("La extensión del archivo no corresponde a una imagen permitida.", null, null);
       
      }
    }
    
    (<HTMLInputElement>document.getElementById('nameFile')).value = "";
    
  }

  elimina() {
  var index: number;
    for (let i = 0; i < this.evidencia.length; ++i) {
      index = this.evidencia.findIndex(item => item.name == this.evidencia[i].name);
      this.evidencia.splice(index, 1);
    }
    this.showBtnAddImagen=true;
    this.showBtnGuardar=false;
    this.nombreImagen="";
    (<HTMLInputElement>document.getElementById('nameFile')).value = "";
  }
}
